import * as React from "react";
import apiClients from "../../apiClients";
import * as Messages from "../../codegen/Messages";
import { parseId } from "../../helpers/idHelper";
import { useMutationCall } from "../../hooks/useMutationCall";
import {
  AsyncNotificationMethodKey,
  AsyncNotificationPolledResponseKey,
  MDS_HEATWAVE_START_POLL_DELAY,
  MDS_HEATWAVE_START_POLL_INTERVAL,
} from "../../models/AsyncNotificationProviders";
import { getOciRegion } from "../../utils";
import { OperationConfirmationProps } from "../OperationTypes";

export interface MysqlStartHeatWaveProps extends OperationConfirmationProps {
  databaseId: string | undefined;
}

const MysqlStartHeatWave = (
  { location, databaseId, onExecute }: MysqlStartHeatWaveProps,
): JSX.Element => {
  const { invokeCall: invokeStart } = useMutationCall(
    { method: apiClients.withRegion(getOciRegion(location)).mdsDatabaseApi.startHeatWaveCluster },
  );

  React.useEffect(() => {
    const { subscriptionId, resourceGroup, resourceName } = parseId(databaseId);
    const resourceGroupName = decodeURIComponent(resourceGroup || "");
    const dbSystemName = decodeURIComponent(resourceName || "");

    const invokeOptions = {
      onSuccess: onExecute,
      notification: {
        inProgress: {
          title: Messages.notifications.inProgress.titles.startHeatWaveCluster(),
          message: Messages.notifications.inProgress.messages.startHeatWaveCluster(dbSystemName),
        },
        success: {
          title: Messages.notifications.success.titles.startHeatWaveCluster(),
          message: Messages.notifications.success.messages.startHeatWaveCluster(dbSystemName),
        },
        failure: {
          title: Messages.notifications.failure.titles.start(),
          message: Messages.notifications.failure.messages.startHeatWaveCluster(dbSystemName),
        },
        asyncPolling: {
          methodKey: AsyncNotificationMethodKey.MDS_HEATWAVE_GET,
          methodArgs: {
            subscriptionId,
            resourceGroupName,
            dbSystemName,
          },
          location,
          responseMethodKey: AsyncNotificationPolledResponseKey.MDS_HEATWAVE_STARTED_CHECK,
          delay: MDS_HEATWAVE_START_POLL_DELAY,
          interval: MDS_HEATWAVE_START_POLL_INTERVAL,
        },
      },
    };
    invokeStart({
      subscriptionId,
      resourceGroupName,
      dbSystemName,
    }, invokeOptions);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div />;
};

export const newMysqlStartHeatWave = (
  props: MysqlStartHeatWaveProps,
): JSX.Element => (<MysqlStartHeatWave {...props} />);
